<template>
  <app-modal>
    <div slot="header">
      <h3>{{ $t('booleanSearch.export') }}</h3>
    </div>
    <div slot="body">
      <load-content :loading="loading" class="position-relative" :class="{ 'py-5': loading }">
        <form-renderer :model="model" :fields="['boolExportFormat', 'boolExportPreventGroupReplace']"
          :show-submit="false" form-wrapper-class="d-block" @updateModel="updateModel" />
      </load-content>
    </div>
    <div slot="footer">
      <div class="btn-container">
        <button class="btn button-save btn-sm mr10" v-on:click="submit" :disabled="buttonsDisabled">
          {{ $t("confirmation.confirm") }}
        </button>
        <button class="btn btn-default btn-sm" tabindex="1" v-on:click="$emit('close')" :disabled="buttonsDisabled">
          {{ $t("confirmation.cancel") }}
        </button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import Modal from '@/components/modal';
import FormRenderer from '@/components/form-renderer';
import LoadContent from '@/components/load-content'

export default {
  data() {
    return {
      model: {
        format: 'csv',
        do_not_replace_group: true
      },
      loading: false
    }
  },

  computed: {
    buttonsDisabled() {
      return this.loading;
    },

    fieldsAdditions() {
      return {
        boolUpload: {
          class: 'd-block m-0'
        }
      }
    }
  },

  methods: {
    updateModel(newValue, field) {
      if (!field) return;
      this.model[field.name] = newValue[field.name];
    },

    submit() {
      this.loading = true;
      this.$emit('export', this.model.format, { do_not_replace_group: this.model.do_not_replace_group }, () => {
        this.loading = false;
        this.$emit('close');
      });
    }
  },

  components: {
    'app-modal': Modal,
    FormRenderer,
    LoadContent
  },

  name: 'ExportResourcesModal'
}
</script>